import { createAxiosInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import { makeCodedException } from 'utils';

export interface ICustomerPortalEnvApi {
    getEnvSettings(): AxiosPromise<EnvSettings>;
}

export const BASE_URL_TOKEN = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class CustomerPortalEnvApi implements ICustomerPortalEnvApi {
    private readonly axios: AxiosInstance;
    constructor(@inject(BASE_URL_TOKEN) @optional() private readonly baseUrl = '') {
        this.axios = createAxiosInstance();
    }

    getEnvSettings(): AxiosPromise<EnvSettings> {
        const url = '/env/settings';
        const options = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            url,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EnvSettings>(options));
    }
}

export interface EnvSettings {
    environmentTag: string;
}
